import React from 'react'
import { Database } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminDiseases = () => {
  return (
    <GenericTable
      tableName="diseases"
      title="Diseases"
      icon={Database}
      iconColor="red"
      searchFields={['disease_name', 'icd_code', 'category', 'severity_level']}
      hiddenFields={['disease_id', 'created_at', 'updated_at']}
      primaryKey="disease_id"
      defaultFields={['disease_id', 'disease_name', 'icd_code', 'category', 'severity_level', 'chronic_flag', 'is_pre_existing_condition', 'coverage_percentage', 'status']}
      addFields={['disease_name', 'icd_code', 'category', 'severity_level', 'chronic_flag', 'is_pre_existing_condition', 'coverage_percentage']}
      editFields={[
        'disease_name', 'icd_code', 'category', 'severity_level', 'chronic_flag', 'is_pre_existing_condition',
        'coverage_percentage', 'waiting_period_months', 'maternity_related', 'pre_approval_required',
        'co_payment_applicable', 'claim_category', 'processing_priority', 'status'
        // Excluded: disease_id, created_at, updated_at
      ]}
    />
  )
}

export default AdminDiseases
